import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";
import { ExpressionBuilder } from "../ExpressionBuilder";
import { getDivideSimpleRule } from "../Testing/MathData";
import { MaxExpression } from "../../rule-engine-core/Expressions/Expressions/Math/MaxExpression";
import { MultiplyExpression } from "../../rule-engine-core/Expressions/Expressions/Math/MultiplyExpression";
import { EqualExpression } from "../../rule-engine-core/Expressions/Expressions/Math/EqualExpression";
import { ModExpression } from "../../rule-engine-core/Expressions/Expressions/Math/ModExpression";
import { RoundExpression } from "../../rule-engine-core/Expressions/Expressions/Math/RoundExpression";
import { AverageExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AverageExpression";
import { NotEqualExpression } from "../../rule-engine-core/Expressions/Expressions/Math/NotEqualExpression";
import { RandomExpression } from "../../rule-engine-core/Expressions/Expressions/Math/RandomExpression";
import { MinExpression } from "../../rule-engine-core/Expressions/Expressions/Math/MinExpression";
import { AddExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AddExpression";
import { SubstractExpression } from "../../rule-engine-core/Expressions/Expressions/Math/SubstractExpression";
import { AsCurrencyExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AsCurrencyExpression";
import { AbsoluteExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AbsoluteExpression";
import { SumExpression } from "../../rule-engine-core/Expressions/Expressions/Math/SumExpression";
import { AsPercentageExpression } from "../../rule-engine-core/Expressions/Expressions/Math/AsPercentageExpression";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

let expression: AppGlueAny;
let exp = new ExpressionConfiguration();

export const ExpressionMathStories = [
    new StoryNode(
        () => {
            expression = new AbsoluteExpression();
            expression.value1.value = -1;
            let exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Absolute",
    ),

    new StoryNode(
        () => {
            expression = new AddExpression();
            expression.value1.value = -1;
            expression.value2.value = 10;
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Add",
    ),

    new StoryNode(
        () => {
            expression = new AsCurrencyExpression();
            expression.value1.value = -1;
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "As Currency",
    ),

    new StoryNode(
        () => {
            expression = new AsPercentageExpression();
            expression.value1.value = -1;
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "As Percent",
    ),

    new StoryNode(
        () => {
            expression = new AverageExpression();
            expression.value1.variableName = "numberList";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Average",
    ),

    new StoryNode(
        () => {
            exp = getDivideSimpleRule();
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Divide",
    ),

    new StoryNode(
        () => {
            expression = new EqualExpression();
            expression.value1.variableName = "value1";
            expression.value2.variableName = "value2";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Equal",
    ),

    new StoryNode(
        () => {
            expression = new MaxExpression();
            expression.value1.variableName = "numberList";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Max",
    ),

    new StoryNode(
        () => {
            expression = new MinExpression();
            expression.value1.variableName = "numberList";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Min",
    ),

    new StoryNode(
        () => {
            expression = new ModExpression();
            expression.value1.variableName = "numberList";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Mod",
    ),

    new StoryNode(
        () => {
            expression = new MultiplyExpression();
            expression.value1.variableName = "value1";
            expression.value2.variableName = "value2";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Multiply",
    ),

    new StoryNode(
        () => {
            expression = new NotEqualExpression();
            expression.value1.variableName = "value1";
            expression.value2.variableName = "value2";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Not Equal",
    ),

    new StoryNode(
        () => {
            expression = new RandomExpression();
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Random",
    ),

    new StoryNode(
        () => {
            expression = new RoundExpression();
            expression.value1.variableName = "value1";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Round",
    ),

    new StoryNode(
        () => {
            expression = new SubstractExpression();
            expression.value1.variableName = "value1";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Subtract",
    ),

    new StoryNode(
        () => {
            expression = new SumExpression();
            expression.value1.variableName = "numberList";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "Math",
        "Sum",
    ),
];
